import React, {useState, Fragment, useEffect} from 'react';
import {showSnackbar} from "../snackbarUtils";
import dayjs from 'dayjs';
import {
    Modal,
    Container,
    Paper,
    Alert,
    Tooltip,
    Grid,
    IconButton,
    TextField,
    Button,
    MenuItem,
    Select,
    Box,
    Checkbox,
    FormControlLabel,
    InputLabel,
    Typography,
    FormControl
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {TimePicker} from '@mui/x-date-pickers/TimePicker';
import 'dayjs/locale/uk'; // Import the Ukrainian locale
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Delete as DeleteIcon} from '@mui/icons-material';
import {DateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import AddIcon from '@mui/icons-material/Add';
import ImageEditor from '../ImageEditorMultiple';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {NavLink} from "react-router-dom";
import api from "../../hooks/useApi";

export default function Form({
                                 fields,
                                 hook,
                                 setFormToOpen,
                                 handleShowModal,
                                 setFieldClicked,
                                 setFieldClickedValue,
                                 revalidator,
                                 newWindowFunction = null,
                                 ...props
                             }) {

    const [visibleField, setVisibleField] = useState({});
    const [isBedroomsHidden, setIsBedroomsHidden] = useState(false);
    const handleVisibleFields = (ev, props, check = false) => {
        const newHiddenFields = {...hiddenFields};  // Копируем текущее состояние

        if (ev.target.name === 'children_obj') {
            const isFilled = Array.isArray(ev.target.value) && ev.target.value.length > 0; // Проверяем, заполнено ли поле

            // Добавляем логику скрытия/показа других полей на основе значения children_obj
            if (isFilled) {
                // Если поле заполнено, скрываем определенные поля, например 'field1' и 'field2'
                newHiddenFields['guest_number'] = true;
                newHiddenFields['bedrooms'] = true;
                newHiddenFields['bathrooms'] = true;
                newHiddenFields['quadrature'] = true;
                newHiddenFields['guest_number_adults'] = true;
                newHiddenFields['guest_number_children'] = true;
                newHiddenFields['children_years_max'] = true;
                newHiddenFields['age_payment_info'] = true;
                newHiddenFields['price'] = true;
                newHiddenFields['rules'] = true;
                newHiddenFields['rates'] = true;
                newHiddenFields['icons'] = true;
                newHiddenFields['with_animals_choices'] = true;
            } else {
                // Если поле не заполнено, показываем эти поля
                newHiddenFields['guest_number'] = false;
                newHiddenFields['bedrooms'] = false;
                newHiddenFields['bathrooms'] = false;
                newHiddenFields['quadrature'] = false;
                newHiddenFields['guest_number_adults'] = false;
                newHiddenFields['guest_number_children'] = false;
                newHiddenFields['children_years_max'] = false;
                newHiddenFields['age_payment_info'] = false;
                newHiddenFields['price'] = false;
                newHiddenFields['rules'] = false;
                newHiddenFields['rates'] = false;
                newHiddenFields['icons'] = false;
                newHiddenFields['with_animals_choices'] = false;
            }

            setIsChildrenObjFilled(isFilled);  // Обновляем состояние для children_obj
        } else if (ev.target.name === 'default_type_beds') {
            const fieldMapping = {
                'single': 'id-number_of_beds_type_single',
                'double': 'id-number_of_beds_type_double',
                'king': 'id-number_of_beds_type_king',
                'super_king': 'id-number_of_beds_type_super_king',
                'bunk': 'id-number_of_beds_type_bunk',
                'sofa_bed': 'id-number_of_beds_type_sofa_bed',
                'futon': 'id-number_of_beds_type_futon',
            };


            // Пройдемся по всем возможным полям
            Object.keys(fieldMapping).forEach((bedType) => {
                const fieldId = fieldMapping[bedType];

                // Если значение выбрано, показываем поле, если нет — скрываем
                if (ev.target.value.includes(bedType)) {
                    document.getElementById(fieldId).style.display = 'block';  // Показываем выбранное поле
                } else {
                    document.getElementById(fieldId).style.display = 'none';  // Скрываем невибранное поле
                }
            });
        } else if (ev.target.name === 'default_bath_placement') {
            const isBedroomPlacement = String(ev.target.value) === 'bedrooms';
            setIsBedroomsHidden(!isBedroomPlacement);
            newHiddenFields['hotel_bedrooms'] = !isBedroomPlacement;
            if (!isBedroomPlacement) {
                hook.setValue('default_hotel_bedrooms', null, {
                    shouldValidate: true,
                    shouldDirty: true,
                });
            }
        } else if (ev.target.name === 'default_payment_type') {
            if (ev.target.value === "free") {
                document.getElementById('id-price_age_info').style.display = 'none';
            } else {
                document.getElementById('id-price_age_info').style.display = 'block';
            }
        }

        // Обновляем словарь скрытых полей
        setHiddenFields(newHiddenFields);

        // Дополнительная логика для других полей
        if (!props.widget_attrs.filed_to_show_id) {
            return;
        }
        const list_of_fields = props.widget_attrs.filed_to_show_id.split('; ');
        const list_to_update = {};

        for (let i of list_of_fields) {
            const defaultLogic = (
                props.widget_attrs.select_variant_form_value === '' ||
                props.widget_attrs.select_variant_form_value === ev.target.value ||
                (props.type === 'CheckboxInput' &&
                    Boolean(props.widget_attrs.select_variant_form_value) === Boolean(ev.target.checked))
            );

            // Якщо поле 'fields' дорівнює 'new_rates', робимо зворотну логіку
            list_to_update[i] = props.widget_attrs.fields === 'new_rates'
                ? !defaultLogic // зворотна логіка
                : defaultLogic;  // звичайна логіка

            // Логіка для поля id_price
            const idPriceElement = document.getElementById('id-price_for_rates');
            if (idPriceElement) {
                if (props.widget_attrs.fields === 'new_rates' && check === false) {
                    idPriceElement.style.display = 'none';
                } else {
                    if (ev.target.name !== "default_another_amount") {
                        idPriceElement.style.display = 'block';
                    }
                }
            }
        }

        setVisibleField({...visibleField, ...list_to_update});
    };

    const createFields = (name, props) => {
        const uniqueName = name === 'image' ? name : `${props.widget_attrs.form_name || 'default'}_${name}`;

        switch (props.type) {
            case 'TextInput':
                return (
                    <TextFieldInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'Textarea':
                return (
                    <TextFieldInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'URLInput':
                return (
                    <TextFieldInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'HiddenInput':
                return (
                    <HiddenInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'NumberInput':
                return (
                    <NumberFieldInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'EmailInput':
                return (
                    <TextFieldInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'CheckboxInput':
                return (
                    <CheckboxInput name={uniqueName} props={props} hook={hook}
                                   handleVisibleFields={handleVisibleFields}/>
                )
            case 'Select':
                return (
                    <SelectOneInput name={uniqueName} props={props} hook={hook}
                                    handleVisibleFields={handleVisibleFields} isBedroomsHidden={isBedroomsHidden}/>
                );
            case 'SelectMultiple':
                return (
                    <SelectMultiple name={uniqueName} props={props} hook={hook}
                                    handleVisibleFields={handleVisibleFields}/>
                );
            case 'TimeInput':
                return (
                    <TimePickerInput name={uniqueName} props={props} hook={hook}/>
                )
            case 'DateInput':
                return (
                    <DatePickerInput name={uniqueName} props={props} hook={hook}/>
                )
            case 'DateTimeInput':
                return (
                    <DateTimePickerInput name={uniqueName} props={props} hook={hook}/>
                )
            case 'CKEditor5Widget':
                return (
                    <CKeditorInput name={uniqueName} props={props} hook={hook}/>
                );
            case 'MultiUploadMetaInput':
                return (
                    <MultiplePhotos name={uniqueName} props={props} hook={hook}/>
                );
            case 'ClearableFileInput':
                return (
                    <SinglePhoto name={uniqueName} props={props} hook={hook}/>
                );
            default:
                return (
                    <NotFoundInput name={uniqueName} props={props}/>
                )
        }
    }

    const [buttonBusy, setButtonBusy] = useState(false);
    const [isChildrenObjFilled, setIsChildrenObjFilled] = useState(false);  // Новый стейт
    const [hiddenFields, setHiddenFields] = useState({});  // Словарь для скрытых полей

    return (
        <>
            {Object.entries(fields).map(([name, props]) => {
                const bathPlacement = hook.watch('default_bath_placement') ?? fields.bath_placement?.initial;
                const bedroomHidden = name === 'hotel_bedrooms' && String(bathPlacement) !== 'bedrooms';
                const isFieldVisible = !hiddenFields[name] && !bedroomHidden && (props.widget_attrs?.style?.display !== 'none' || visibleField[`id_${name}`]);

                return (
                    <Fragment key={name}>
                        <Grid
                            xs={12}
                            item
                            key={name}
                            sx={{
                                maxWidth: '100%',
                                width: '100%',
                                display: isFieldVisible ? 'block' : 'none',  // Управляем видимостью через display
                            }}
                            id={`id-${name}`}
                        >
                            <div style={{width: '100%'}}>
                                {createFields(name, props)} {/* Отображаем поле всегда, но скрываем через стиль */}
                            </div>
                            {/* Отображаем кнопку только если поле видно */}
                            {props.widget_attrs.need_Button === true && !props.widget_attrs.select_variant_form_value && (
                                <Button
                                    variant="contained"
                                    sx={{mt: 1}}
                                    startIcon={<AddIcon/>}
                                    disabled={buttonBusy}
                                    onClick={() => {
                                        if (name === 'children_obj') {
                                            // console.log('before window open');
                                            sessionStorage.setItem('children_obj', JSON.stringify(props.choices.map(el => el[0])));
                                            newWindowFunction(setButtonBusy, 'Obj_Children');
                                        } else if (name === 'location') {
                                            // console.log('before window open for location');
                                            sessionStorage.setItem('location', JSON.stringify(props.choices.map(el => el[0])));
                                            newWindowFunction(setButtonBusy, 'Obj_Location');
                                        } else {
                                            setFormToOpen(props.widget_attrs.form_name);
                                            setFieldClicked(name);
                                            setFieldClickedValue(props.choices.map(el => el[0]));
                                            handleShowModal();
                                        }
                                    }}
                                >
                                    {props.label}
                                </Button>
                            )}
                        </Grid>
                    </Fragment>
                );
            })}
        </>
    );

}


const MultiplePhotos = ({name, props, hook}) => {
    const [imagesList, setImagesList] = useState(props.initial);
    const [openModal, setOpenModal] = useState(false);
    const [index, setIndex] = useState(null);
    const [OpenModalImageDescriptions, setOpenModalImageDescriptions] = useState(false);
    const [description, setDescription] = useState(() => {
        try {
            const initialDescriptions = props.widget_attrs.data_image_descriptions;
            return Array.isArray(initialDescriptions)
                ? initialDescriptions
                : JSON.parse(initialDescriptions || '[]'); // Парсим JSON, если передана строка
        } catch (e) {
            console.error("Invalid initial description format", e);
            return [];
        }
    });
    const [error, setError] = useState(null); // Для отображения ошибок API
    const maxDescriptionLength = props.widget_attrs.data_image_descriptions_maxLength || 50;

    useEffect(() => {
        if (props.initial && props.initial.length > 0) {
            setImagesList(props.initial);
            hook.setValue(name, props.initial); // Устанавливаем начальные данные в форму
        }
    }, [props.initial, name, hook]);

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files).filter(file => file instanceof File);
        const currentImages = hook.getValues(name) ?? [];

        // Максимальное количество изображений
        const maxImages = props.widget_attrs.max_length || Infinity;

        // Лимит размера файла в байтах (500 КБ)
        const maxFileSize = 500 * 1024;

        // Максимальная длина имени файла
        const maxFileNameLength = 100;

        // Проверяем, не превышает ли количество изображений лимит
        if (currentImages.length + files.length > maxImages) {
            alert(`Максимальна кількість фото: ${maxImages}`);
            return;
        }

        // Фильтруем файлы, которые превышают лимит по размеру
        const validFiles = files.filter(file => {
            if (file.size > maxFileSize) {
                alert(`Файл ${file.name} перевищує максимальний розмір 500 КБ.`);
                return false;
            }
            return true;
        });

        // Сокращение имени файла, если оно слишком длинное
        const renamedFiles = validFiles.map(file => {
            if (file.name.length > maxFileNameLength) {
                const extension = file.name.split('.').pop(); // Получаем расширение файла
                const shortenedName = file.name.slice(0, maxFileNameLength - extension.length - 1) + '.' + extension;
                return new File([file], shortenedName, {type: file.type});
            }
            return file;
        });

        // Добавляем только уникальные и допустимые по размеру файлы
        const newFiles = validFiles.filter(file =>
            Array.isArray(currentImages) && !currentImages.some(image => image.name === file.name && image.size === file.size)
        );

        const updatedImages = [...currentImages, ...newFiles]; // Добавляем только уникальные файлы

        hook.setValue(name, updatedImages); // Обновляем значение в форме
        setImagesList(updatedImages); // Обновляем локальное состояние для отображения
    };


    const handleDelete = (index) => {
        const currentImages = hook.getValues(name);

        // Удаляем изображение по индексу
        const updatedImages = currentImages.filter((_, i) => i !== index);

        // Обновляем состояние формы и список изображений
        hook.setValue(name, updatedImages);
        setImagesList(updatedImages);
    };

    const handleEdit = (index) => {
        setIndex(index);
        setOpenModal(true);
    };
    const handleDragStart = (event, index) => {
        event.dataTransfer.setData('draggedIndex', index);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event, dropIndex) => {
        const draggedIndex = event.dataTransfer.getData('draggedIndex');
        if (draggedIndex !== null) {
            const currentImages = hook.getValues(name);
            const reorderedImages = [...currentImages];
            const [draggedImage] = reorderedImages.splice(draggedIndex, 1);
            reorderedImages.splice(dropIndex, 0, draggedImage);

            hook.setValue(name, reorderedImages);
            setImagesList(reorderedImages);
        }
    };

    const handleEditedImage = (file, index) => {
        const currentImages = hook.getValues(name);
        const updatedImages = [...currentImages];
        updatedImages[index] = file;
        setImagesList(updatedImages);
        hook.setValue(name, updatedImages);
    }

    const handleEditImageDescriptions = (index) => {
        setIndex(index);
        setOpenModalImageDescriptions(true);
    };

    const handleSubmitDescription = async () => {
        try {
            setError(null);

            const formData = new FormData();
            formData.append('image_descriptions', JSON.stringify(description)); // Отправляем массив описаний
            formData.append('image_index', index);
            formData.append('update_images', true);

            const response = await api.patch(
                `/api/${props.widget_attrs.form}/${props.widget_attrs.HotelID}/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            showSnackbar('Опис успішно оновлено! Для перегляду оновіть сторінку', "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });
            setOpenModalImageDescriptions(false);
        } catch (err) {
            showSnackbar('Сталася помилка: ' + err.message, 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    };

    const img_url = index !== null && hook.getValues(name)[index] ? URL.createObjectURL(hook.getValues(name)[index]) : null;
    return (
        <div>
            <input
                {...hook.register(name, {
                    required: props.required && "Обов'язкове поле",
                    maxLength: {
                        value: props.widget_attrs.max_length || Infinity,
                        message: `Максимальна кількість фото ${props.widget_attrs.max_length}`,
                    },
                    minLength: {
                        value: props.widget_attrs.min_length || 0,
                        message: `Мінімальна кількість фото ${props.widget_attrs.min_length}`,
                    },
                })}
                defaultValue={props.initial}
                hidden
            />
            <input
                //{...hook.register(name, { required: props.required })}
                id={`id-label-${name}`}
                type="file"
                accept="image/png, image/jpeg"
                multiple
                onChange={handleFileChange}
                style={{display: 'none'}}
                // Register input with react-hook-form
            />
            <Typography variant="subtitle1" gutterBottom>
                {props.label || 'Зображення:'}
            </Typography>

            {imagesList?.length > 0 && (
                <div>
                    <Grid container spacing={2} sx={{marginBottom: 1}}>
                        {imagesList?.map((image, index) => (
                            <Grid item key={index}
                                  xs={6} sm={4} md={3} lg={2}
                                  draggable
                                  onDragStart={(event) => handleDragStart(event, index)}
                                  onDragOver={handleDragOver}
                                  onDrop={(event) => handleDrop(event, index)}
                            >
                                <div style={{position: 'relative', width: '100%', height: '150px', overflow: 'auto'}}>
                                    {image instanceof File ? (
                                        <img src={URL.createObjectURL(image)} alt={`-${index}`}
                                             style={{width: '100%', height: 'auto', objectFit: 'cover'}}/>
                                    ) : (
                                        <div>Invalid image file</div>
                                    )}

                                    <Tooltip title="Видалити">
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => handleDelete(index)}
                                            sx={{
                                                position: 'absolute',
                                                top: 5, right: 5,
                                                background: 'white',
                                                '&:hover': {
                                                    backgroundColor: '#FF4D4D',
                                                    color: 'black'
                                                },
                                            }}
                                        >
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        textAlign: 'left',
                                        marginBottom: 3, // Отступ сверху
                                        color: '#555', // Серый текст
                                        fontSize: '1rem',
                                        maxWidth: '1%', // Ограничиваем ширину описания
                                    }}
                                >
                                    {props.widget_attrs.data_image_descriptions[index] || ""}
                                </Typography>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start'
                                }}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        sx={{my: 1}} // Задаем фиксированную ширину
                                        fullWidth
                                        endIcon={<DescriptionIcon/>}
                                        onClick={() => handleEditImageDescriptions(index)}
                                    >
                                        ЗМІНИТИ ОПИС
                                    </Button>
                                    <Button type="button"
                                            variant='contained'
                                            sx={{my: 1}}
                                            fullWidth
                                            endIcon={<EditOutlinedIcon/>}
                                            onClick={() => handleEdit(index)}>
                                        РЕДАГУВАТИ
                                    </Button>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                    {OpenModalImageDescriptions && (
                        <Modal open={true} onClose={() => OpenModalImageDescriptions(false)}
                               className="flex abs-center">
                            <Container maxWidth="sm">
                                <Paper sx={{p: 3}}>
                                    <Typography variant="h6" gutterBottom>
                                        Редагувати опис картинки
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        label="Опис"
                                        value={description[index] || ""}
                                        onChange={(e) => {
                                            const updatedDescriptions = [...description]; // Создаем копию массива
                                            updatedDescriptions[index] = e.target.value; // Обновляем конкретное описание
                                            setDescription(updatedDescriptions); // Устанавливаем новое состояние
                                        }}
                                        multiline
                                        rows={1}
                                        sx={{mb: 2}}
                                        inputProps={{maxLength: maxDescriptionLength}}
                                    />
                                    {error && (
                                        <Alert severity="error" sx={{mb: 2}}>
                                            {error}
                                        </Alert>
                                    )}
                                    <Box display="flex" justifyContent="space-between">
                                        <Button
                                            variant="outlined"
                                            onClick={() => setOpenModalImageDescriptions(false)}
                                        >
                                            Скасувати
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={handleSubmitDescription}
                                        >
                                            Зберегти
                                        </Button>
                                    </Box>
                                </Paper>
                            </Container>
                        </Modal>
                    )}
                    {openModal && (
                        <Modal
                            open={true}
                            className='flex abs-center'>
                            <Container maxWidth='md' sx={{height: '100%'}}>
                                <Paper
                                    sx={{height: '95%', p: 1, overflow: 'auto'}}
                                >
                                    <ImageEditor
                                        img_url={img_url}
                                        index={index}
                                        setOpenModal={setOpenModal}
                                        handleEditedImage={handleEditedImage}
                                        single={false}
                                    />
                                </Paper>
                            </Container>
                        </Modal>
                    )}
                </div>
            )}
            <label htmlFor={`id-label-${name}`} /*style={{ display: (selectedImages.length ? 'none' : '') }}*/>
                <Button variant="contained" component="span" sx={{textTransform: 'uppercase'}}>
                    додати
                </Button>
            </label>
            {hook.formState.errors[name] && (
                <div>
                    <Alert severity="error">
                        {hook.formState.errors[name].message || 'Перевірте правильність введених даних'}
                    </Alert>
                </div>
            )}


        </div>
    )
}
const SinglePhoto = ({name, props, hook}) => {
    const [imagesList, setImagesList] = useState(props.initial);
    const [openModal, setOpenModal] = useState(false);
    const [OpenModalImageDescriptions, setOpenModalImageDescriptions] = useState(false);
    const [description, setDescription] = useState(props.widget_attrs.data_image_descriptions || '');
    const maxDescriptionLength = props.widget_attrs.data_image_descriptions_maxLength || 50;
    const [error, setError] = useState(null); // Для отображения ошибок API
    const index = 0;

    const handleFileChange = (event) => {
        const file = event.target.files[0]; // Получаем первое (и единственное) выбранное изображение
        const maxFileSize = 500 * 1024; // Максимальный размер файла - 500 КБ

        // Проверяем размер файла
        if (file.size > maxFileSize) {
            alert(`Файл ${file.name} перевищує максимальний розмір 500 КБ.`);
            return; // Если файл слишком большой, не добавляем его
        }

        hook.setValue(name, file); // Обновляем состояние формы
        setImagesList(file); // Обновляем локальное состояние
    };

    const handleDelete = () => {
        hook.setValue(name, null); // Update form state
        setImagesList(null)
    };

    const handleEdit = (index) => {
        setOpenModal(true);
    };

    const handleEditImageDescriptions = (index) => {
        setOpenModalImageDescriptions(true);
    };

    const handleEditedImage = (file, index) => {
        setImagesList(file);
        hook.setValue(name, file);
    }

    const handleSubmitDescription = async () => {
        try {
            setError(null); // Сбрасываем ошибки

            const formData = new FormData();
            formData.append('image_descriptions', description);

            const response = await api.patch(`/api/${props.widget_attrs.form}/${props.widget_attrs.HotelID}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'  // Set Content-Type
                }
            });

            showSnackbar('Опис успішно оновлено! Для перегляду оновіть сторінку', "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });
            setOpenModalImageDescriptions(false); // Закрываем модальное окно
        } catch (err) {
            throw new Error(err.message);
        }
    };

    const img_url = hook.getValues(name) ? URL.createObjectURL(hook.getValues(name)) : null;

    return (
        <>
            <div>
                <input
                    {...hook.register(name, {
                        required: props.required && "Обов'язкове поле"
                    })}
                    defaultValue={props.initial}
                    hidden
                />
                <input

                    type="file"
                    id={`id-label-${name}`}
                    accept="image/png, image/jpeg"
                    onChange={handleFileChange}
                    style={{display: 'none'}}
                />
                <Typography variant="subtitle1" gutterBottom>
                    {props.label || 'Зображення:'}
                </Typography>
                {imagesList && (
                    <>
                        <div style={{
                            position: 'relative',
                            width: '100%',
                            height: '150px',
                            overflow: 'hidden',
                            marginBottom: 1
                        }}>
                            <Grid item xs={6} sm={4} md={3} lg={2}>
                                <div style={{position: 'relative', width: '100%', height: '150px', overflow: 'auto'}}>
                                    <img src={URL.createObjectURL(imagesList)} alt="selected"
                                         style={{width: '100%', height: 'auto', objectFit: 'cover'}}/>
                                    <Tooltip title="Видалити">
                                        <IconButton
                                            aria-label="delete"
                                            onClick={handleDelete}
                                            sx={{
                                                position: 'absolute',
                                                top: 5, right: 5,
                                                background: 'white',
                                                '&:hover': {
                                                    backgroundColor: '#FF4D4D',
                                                    color: 'black'
                                                },
                                            }}
                                        >
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </div>

                            </Grid>
                        </div>
                        <Typography
                            variant="body1"
                            sx={{
                                textAlign: 'left',
                                marginBottom: 3, // Отступ сверху
                                color: '#555', // Серый текст
                                fontSize: '1rem',
                                fontWeight: '400',
                                maxWidth: '80%', // Ограничиваем ширину описания
                            }}
                        >
                            {props.widget_attrs.data_image_descriptions}
                        </Typography>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'flex-start'}}>
                            <Button
                                type="button"
                                variant="outlined"
                                sx={{width: '250px'}} // Задаем фиксированную ширину
                                endIcon={<DescriptionIcon/>}
                                onClick={() => handleEditImageDescriptions(true)}
                            >
                                ЗМІНИТИ ОПИС
                            </Button>
                            <Button
                                type="button"
                                variant="contained"
                                sx={{width: '250px'}} // Задаем ту же ширину
                                endIcon={<EditOutlinedIcon/>}
                                onClick={() => handleEdit(index)}
                            >
                                РЕДАГУВАТИ ФОТО
                            </Button>
                        </div>
                    </>
                )}
                <label htmlFor={`id-label-${name}`} style={{display: imagesList ? 'none' : 'block'}}>
                    <Button variant="contained" component="span" sx={{textTransform: 'uppercase'}}>
                        Обрати зображення...
                    </Button>
                </label>
                {hook.formState.errors[name] && (
                    <Alert severity="error">
                        {hook.formState.errors[name].message || 'Перевірте правильність введених даних'}
                    </Alert>
                )}
            </div>
            {OpenModalImageDescriptions && (
                <Modal open={true} onClose={() => OpenModalImageDescriptions(false)} className="flex abs-center">
                    <Container maxWidth="sm">
                        <Paper sx={{p: 3}}>
                            <Typography variant="h6" gutterBottom>
                                Редагувати опис основної картинки
                            </Typography>
                            <TextField
                                fullWidth
                                label="Опис"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                multiline
                                rows={1}
                                sx={{mb: 2}}
                                inputProps={{maxLength: maxDescriptionLength}}
                            />
                            {error && (
                                <Alert severity="error" sx={{mb: 2}}>
                                    {error}
                                </Alert>
                            )}
                            <Box display="flex" justifyContent="space-between">
                                <Button
                                    variant="outlined"
                                    onClick={() => setOpenModalImageDescriptions(false)}
                                >
                                    Скасувати
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleSubmitDescription}
                                >
                                    Зберегти
                                </Button>
                            </Box>
                        </Paper>
                    </Container>
                </Modal>
            )}
            {openModal && (
                <Modal
                    open={true}
                    className='flex abs-center'>
                    <Container maxWidth='md' sx={{height: '100%'}}>
                        <Paper
                            sx={{height: '95%', p: 1, overflow: 'auto'}}
                        >
                            <ImageEditor
                                img_url={img_url}
                                index={index}
                                setOpenModal={setOpenModal}
                                handleEditedImage={handleEditedImage}
                                single={true}
                            />
                        </Paper>
                    </Container>
                </Modal>
            )}
        </>
    );
};
export const CheckboxInput = ({name, props, hook, handleVisibleFields}) => {
    const {
        register,
        setValue,
        watch,
        formState: {errors}
    } = hook;

    const checked = Boolean(watch(name) ?? props.initial);

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        {...register(name, {required: props.required})}
                        checked={checked}
                        onChange={(ev) => {
                            const newChecked = ev.target.checked;
                            setValue(name, newChecked, {
                                shouldValidate: true,
                                shouldDirty: true,
                            });
                            handleVisibleFields(ev, props, newChecked);
                        }}
                    />
                }
                label={props.label}
            />
            {errors[name] && (
                <Alert severity="error">
                    {errors[name].message || "Обов'язкове поле"}
                </Alert>
            )}
        </>
    );
};
const SelectMultiple = ({name, props, hook, handleVisibleFields}) => {
    const {
        register,
        formState: {errors}
    } = hook;
    const getDefault = (hook.getValues(name) || props.initial) ?? [];

    const defaultValue = Array.isArray(getDefault) ? getDefault : [getDefault];
    //console.log({hook: hook.getValues(name), initial: props.initial})
    //console.log(defaultValue)
    const handleChange = (event) => {
        const {value} = event.target;
        hook.setValue(name, value); // Обновляем значение в форме

        // Вызываем handleVisibleFields для обновления видимости других полей
        handleVisibleFields(event, props);
    };

    return (
        <FormControl fullWidth>
            <InputLabel id={`id-${name}-label`}>{props.label}</InputLabel>
            <Select
                {...register(name, {required: props.required && 'Обов\'язкове поле',})}
                labelId={`id-${name}-label`}
                id={`id-input-${name}`}
                label={props.label}
                multiple
                defaultValue={defaultValue}
                variant='outlined'
                error={errors[name] ? true : false}
                sx={{width: '100%'}}
                onChange={handleChange}
            >
                {props.choices.map(([value, title]) => (
                    <MenuItem key={value} value={value}>
                        {title}
                    </MenuItem>
                ))}
            </Select>
            {errors[name] && (<Alert severity='error'>
                {errors[name].message ? errors[name].message : ''}
            </Alert>)
            }
        </FormControl>
    )
}
const SelectOneInput = ({name, props, hook, handleVisibleFields, isBedroomsHidden}) => {
    const {
        register,
        formState: {errors}
    } = hook;
    const isBedroomField = name === 'default_hotel_bedrooms';
    const bedroomRequired = !isBedroomField || String(hook.watch('default_bath_placement') ?? '') === 'bedrooms';
    return (
        <FormControl fullWidth>
            <InputLabel id={`id-label-${name}`}>{props.label}</InputLabel>
            <Select
                {...register(name, {required: props.required && bedroomRequired && 'Обов\'язкове поле',})}
                labelId={`id-label-${name}`}
                label={props.label}
                defaultValue={(hook.getValues(name) || props.initial) ?? ''}
                variant='outlined'
                error={errors[name] ? true : false}
                sx={{width: '100%'}}
                onChange={(ev) => {
                    handleVisibleFields(ev, props);
                }}
            >
                {props.choices && props.choices
                    .map(([value, title]) => (
                        <MenuItem key={value} value={value}>
                            {title}
                        </MenuItem>
                    ))}
            </Select>
            {errors[name] && (<Alert severity='error'>
                {errors[name].message ? errors[name].message : ''}
            </Alert>)
            }
        </FormControl>
    )
}
const TimePickerInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
        setValue
    } = hook;
    const defaultVal = hook.getValues(name) || props.initial || undefined;
    return (
        <TimePicker
            {...register(name, {required: props.required})}
            label={props.label}
            defaultValue={defaultVal ? dayjs(defaultVal) : undefined}
            error={errors[name] ? true : false}
            sx={{width: '100%'}}
            onChange={(date) => setValue(name, dayjs(date).format('HH:mm:[00]'))}//handleDateRangeChange(date, name)}
            ampm={false} // Set ampm prop to false for 24-hour format
        />
    )
}
const CKeditorInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
        setValue
    } = hook;

    return (
        <>
            <input
                type="hidden"
                name={name}
                {...register(name, {required: props.required})}
            />
            <Typography variant="subtitle1" gutterBottom>
                {props.label || 'Опис:'}
            </Typography>
            <CKEditor
                editor={ClassicEditor}
                data={(hook.getValues(name) || props.initial) ?? ''}
                config={{
                    toolbar: [
                        'undo',
                        'redo',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'blockQuote'
                    ],
                }}
                style={{width: '100%'}}
                onChange={(event, editor) => {
                    const content = editor.getData();
                    //setInputValue(content);
                    // Update the hidden input field value with the CKEditor content
                    setValue(name, content);
                }}
            />
            {errors[name] && (<Alert severity="error">Обов'язкове поле</Alert>)}
        </>
    )
}
export const DateTimePickerInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
        setValue
    } = hook;
    const defaultVal = hook.getValues(name) || props.initial || undefined;

    return (
        <DateTimePicker
            {...register(name, {required: props.required})}
            label={props.label}
            defaultValue={defaultVal ? dayjs(defaultVal) : undefined}
            sx={{width: '100%'}}
            error={errors[name] ? true : false}
            slotProps={{
                textField: {
                    fullWidth: true,
                    error: Boolean(errors[name]),
                    helperText: errors[name]?.message,
                },
            }}
            onChange={(date) => setValue(name, dayjs(date).format('YYYY-MM-DD HH:mm:[00]'))}//handleDateRangeChange(date, name)}
        />
    )
}
const DatePickerInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
        setValue
    } = hook;
    const defaultVal = hook.getValues(name) || props.initial || undefined;
    return (
        <FormControl fullWidth>
            <DatePicker
                fullWidth
                {...register(name, {required: props.required})}
                label={props.label}
                defaultValue={defaultVal ? dayjs(defaultVal) : undefined}
                style={{width: '100%'}}
                error={errors[name] ? true : false}
                onChange={(date) => setValue(name, dayjs(date).format('YYYY-MM-DD'))}//handleDateRangeChange(date, name)}
            />
        </FormControl>
    )
}


export const TextFieldInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
        trigger,
    } = hook;

    const dict = {
        'TextInput': 'text',
        'URLInput': 'url',
        'EmailInput': 'email',
    };

    return (
        <TextField
            {...register(name, {
                required: props.required && 'Обов\'язкове поле',
                maxLength: {
                    value: props.max_length || Infinity,
                    message: `Максимальна довжина ${props.max_length} символів`,
                },
                minLength: {
                    value: props.min_length || 0,
                    message: `Мінімальна довжина ${props.min_length} символів`,
                },
            })}
            label={props.label}
            type={name === 'password' ? 'password' : dict[props.type]}
            defaultValue={props.initial ?? ''}
            variant="outlined"
            onBlur={() => trigger(name)}
            inputMode="text"
            helperText={errors[name] && errors[name].message ? errors[name].message : ''}
            error={errors[name] ? true : false}
            sx={{width: '100%'}}
        />
    );
};


export const HiddenInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
    } = hook;

    // Проверяем, нужно ли отображать поле (в большинстве случаев для hidden полей это не нужно)
    if (!props.initial && !hook.getValues(name)) {
        return null; // Не рендерим, если нет значения
    }

    return (
        <input
            {...register(name, {
                required: props.required && 'Обов\'язкове поле',
                maxLength: {
                    value: props.max_length || Infinity,
                    message: `Максимальна довжина ${props.max_length} символів`,
                },
                minLength: {
                    value: props.min_length || 0,
                    message: `Мінімальна довжина ${props.min_length} символів`,
                },
            })}
            type="hidden"
            defaultValue={hook.getValues(name) || props.initial || ''}
            style={{
                display: 'none', // Скрывает элемент полностью
                visibility: 'hidden', // Делаем элемент невидимым
                position: 'absolute', // Избавляемся от влияния на поток документа
                left: '-9999px', // Убираем элемент за пределы видимой области
            }}
        />
    );
};


export const NumberFieldInput = ({name, props, hook}) => {
    const {
        register,
        formState: {errors},
        trigger,
        setValue,
        getValues,
    } = hook;

    const handleChange = (event) => {
        const {name: fieldName, value} = event.target;

        if (fieldName === 'default_min_leave_night') {
            if (value === '') {
                return; // Даем возможность очистить поле перед вводом нового значения
            }

            const numericValue = Number(value);
            if (Number.isNaN(numericValue) || numericValue <= 1) {
                setValue(fieldName, 2);
                // } else if (numericValue => 0 && numericValue <= 1) {
                //     setValue(fieldName, 2);
            } else {
                setValue(fieldName, numericValue); // Устанавливаем новое значение в поле
            }
        } else {
            if (value === '' || isNaN(value)) {
                setValue(event.target.name, 0); // Принудительно устанавливаем значение на 0, если введено некорректное значение
            } else if (value < 0) {
                setValue(event.target.name, 0); // Принудительно устанавливаем значение на 0, если введено меньше
            } else {
                setValue(event.target.name, value); // Устанавливаем новое значение в поле
            }
        }

        if (event.target.name === 'default_guest_number_adults') {
            const adultsValue = parseInt(event.target.value, 10) || 0;  // Проверяем и устанавливаем 0, если значение некорректное
            const guestValue = parseInt(getValues('default_guest_number'), 10) || 0;
            const childValue = parseInt(event.target.value, 10) || 0;

            if (adultsValue >= guestValue) {
                // Если количество взрослых больше общего числа гостей, устанавливаем взрослых равными общему числу гостей
                if (childValue === 0) {
                    setValue('default_guest_number_adults', guestValue);
                } else {
                    setValue('default_guest_number_adults', guestValue);
                }
                if (childValue > guestValue) {
                    // Иначе рассчитываем количество детей
                    setValue('default_guest_number_children', Math.max(guestValue, 0));
                }// Используем Math.max, чтобы избежать отрицательных значений
            } else {
                if (childValue > guestValue) {
                    // Иначе рассчитываем количество детей
                    setValue('default_guest_number_children', Math.max(guestValue, 0));
                }// Используем Math.max, чтобы избежать отрицательных значений
            }
        } else if (event.target.name === 'default_guest_number') {
            const adultsValue = parseInt(getValues('default_guest_number_adults'), 10) || 0;
            const guestValue = parseInt(event.target.value, 10) || 0;
            const childValue = parseInt(event.target.value, 10) || 0;

            if (adultsValue === guestValue && adultsValue > guestValue && childValue === 0) {
                // Если количество взрослых больше общего числа гостей, устанавливаем взрослых равными общему числу гостей
                setValue('default_guest_number_adults', guestValue);
                //setValue('default_guest_number_children', 0);
            } else {
                // Иначе рассчитываем количество детей
                setValue('default_guest_number_children', Math.max(guestValue - 1, 0));  // Используем Math.max, чтобы избежать отрицательных значений
                setValue('default_guest_number_adults', Math.max(guestValue - 1, 0));  // Используем Math.max, чтобы избежать отрицательных значений
            }
        } else {
            const adultsValue = parseInt(getValues('default_guest_number_adults'), 10) || 0;
            const guestValue = parseInt(getValues('default_guest_number'), 10) || 0;
            const childValue = parseInt(event.target.value, 10) || 0;  // Проверяем и устанавливаем 0, если значение некорректное

            if (childValue >= guestValue) {
                setValue('default_guest_number_children', guestValue);
            } else {
                //setValue('default_guest_number_children', Math.max(guestValue - adultsValue, 0));  // Используем Math.max, чтобы избежать отрицательных значений
            }
        }
    };

    const handleBlur = () => {
        if (name === 'default_min_leave_night') {
            const currentValue = getValues(name);
            if (currentValue === '' || currentValue === null || Number.isNaN(currentValue) || currentValue < 0) {
                setValue(name, 2);
            }
        }

        trigger(name);
    };

    return (
        <TextField
            {...register(name, {
                required: props.required && 'Обов\'язкове поле',
                min: {
                    value: props.min_value || 0,
                    message: `Мінімальне значення ${props.min_value || 0}`,
                },
                max: {
                    value: props.max_value || Infinity,
                    message: `Максимальне значення ${props.max_value}`,
                },
                valueAsNumber: true
            })}
            label={props.label}
            type="number"
            defaultValue={props.initial ?? ''}
            variant="outlined"
            onBlur={() => trigger(name)}
            onChange={handleChange}
            inputMode="numeric"
            helperText={errors[name] && errors[name].message ? errors[name].message : ''}
            error={errors[name] ? true : false}
            sx={{width: '100%'}}
            inputProps={{min: 0}} // Ограничение на уровне HTML
        />
    );
};


const NotFoundInput = ({name, props}) => {
    return (
        <Box>
            <Box>
                Поле введення не знайдено!
                Назва поля:{name}
            </Box>
            <Box sx={{overflow: 'scroll', maxHeight: '25px', maxWidth: '100%'}}>
                {JSON.stringify(props)}
            </Box>
        </Box>
    )
}
/**
 const copypaste = ({ name, props, hook }) => {
 const {
 register,
 formState: { errors }
 } = hook;
 return (
 <>
 </>
 )
 }
 */

